/**
 * Reason why a driver was automatically unselected (stashed)
 */
export type StashReason =
  | 'interval_incompatible' // Driver interval doesn't match selected frequency
  | 'inactive_from_api' // API returned is_active=false for this driver
  | 'missing_from_api' // Driver no longer exists in fresh API data

/**
 * Represents a driver that was automatically unselected
 * with tracking for the reason it was stashed
 */
export interface StashedDriver {
  id: number
  reason: StashReason
  driverName?: string // For better toast messages
}

/**
 * Get a human-readable tooltip message for a stash reason
 */
export const getStashReasonTooltip = (reason: StashReason): string => {
  switch (reason) {
    case 'interval_incompatible':
      return "This driver's granularity is incompatible with the selected frequency"
    case 'inactive_from_api':
      return 'This driver is not available for the selected timeframe/frequency'
    case 'missing_from_api':
      return 'This driver is no longer available'
    default:
      return 'This driver was automatically unselected'
  }
}
